import { createContext } from "react";

export const ErrorContext = createContext();

export const ErrorContextProvider = ({ children }) => {

    const parseErrors = (error) => {
        const type = typeof error;
        switch (type) {
            case 'string':
                return [{message: error}]
            case 'object':
                let errors = []
                if (Array.isArray(error)) {
                    for (let e of error) {
                        if (e.msg) {
                            errors.push({message: e.msg})
                        } else {
                            errors.push({message: JSON.stringify(e)})
                        }
                    }
                } else {
                    errors.push({message: JSON.stringify(error)})
                }
                return errors;
            default:
                return [{message: JSON.stringify(error)}]
        }
    }

    return (
        <ErrorContext.Provider value={{ parseErrors }}>
            {children}
        </ErrorContext.Provider>
    )
}